import { api } from "../../services/axios";
import { googleApi } from "../../services/googleApi";
import Cookies from "js-cookie";

export const useYt = () => {
  const handleAeskinsVideos = async () => {
    try {
      const { data } = await api.get(
        "/portalCliente/cursos",
        {
          params: {
            user: Cookies.get("codparc"),
          },
        },
        {
          headers: {
            Authorization: "Bearer " + Cookies.get("bearer"),
          },
        },
      );

      const courses = data.map(async (course) => {
        if (course.STREAMING === "YOUTUBE") {
          const { data } = await googleApi.get(
            `/youtube/v3/videos?part=snippet&id=${course?.LINK}&key=AIzaSyCucbVtabqf6ACuW79RqBl1kIMDwarmauA`,
          );

          return {
            title:
              data?.items?.[0]?.snippet?.title ||
              course?.TITULO ||
              "Sem título",
            description:
              data?.items?.[0]?.snippet?.description ||
              course?.DESCRICAO ||
              "Sem descrição",
            id: `https://www.youtube.com/watch?v=${course?.LINK}`,
            course: course?.NOMECURSO || "Curso sem título",
          };
        }

        return {
          title: course?.TITULO || "Sem título",
          description: course?.DESCRICAO || "Sem descrição",
          id: `https://vimeo.com/${course?.LINK}`,
          course: course?.NOMECURSO || "Curso sem título",
        };
      });

      const videosDetails = await Promise.all(courses);

      const groupedByTopic = {};

      videosDetails.forEach((item, idx) => {
        const topic = data[idx]?.TOPICO || "Sem tópico";
        const course = item.course || "Curso sem título";
        if (!groupedByTopic[topic]) {
          groupedByTopic[topic] = {};
        }
        if (!groupedByTopic[topic][course]) {
          groupedByTopic[topic][course] = [];
        }
        groupedByTopic[topic][course].push(item);
      });

      Object.keys(groupedByTopic).forEach((topic) => {
        Object.keys(groupedByTopic[topic]).forEach((course) => {
          groupedByTopic[topic][course] = groupedByTopic[topic][course].sort(
            (a, b) => a.title.localeCompare(b.title),
          );
        });
      });

      return groupedByTopic;
    } catch (error) {
      console.error(error);
    }
  };

  return { handleAeskinsVideos };
};
